module.exports = __webpack_public_path__ + "static/assets/31a4f73fe4fb2dab86003c53e46c2529.svg";